function showUp(dom){
    gsap.from(dom, {
        y: '2rem', opacity: 0, ease: 'none', duration: 0.5,
        scrollTrigger: {
            trigger: dom,
            start: 'top bottom-=20%',
            end: '+=0',
            //toggleActions: 'play none none reverse',
        }
    })
}

function onViewLoad(className) {
    const elements = $(className).get();
    
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                const video = entry.target
                video.src = video.dataset.src
                video.load()
                observer.unobserve(video);
            }
        });
    }, { threshold:0,rootMargin: '500px', });
    
    elements.forEach(el => observer.observe(el));
}

var wFlag = window.innerWidth > 750

//提前加载图片
const preloadImages = () => {
    for(let i=1;i<39;i++){
        if(i==38){
            i=39
        }
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/cresmo_box4_${i}.avif`;
    }
    for(let a=1;a<20;a++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/cresmo_box9_${a}.avif?v=1783049894`;
    }
    
};
preloadImages()

onViewLoad('.lazy_video')

$(()=>{
    setInterval(() => {
        $('.box1_title').css({ transform: 'translateY(0)', opacity: 1 })
    }, 300);

    //box2
    ScrollTrigger.create({
        trigger:'.box2_items',
        start:'top bottom-=30%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box2_items div',{y:'2rem',opacity:0,stagger:0.2})
    })

    //box3
    ScrollTrigger.create({
        trigger:'.box3',
        start:'top top+=4%',
        end:'+=80%',
        pin:true,
        onUpdate: function (self) {
            let index = Math.floor(self.progress * 10);
            $('.box3').toggleClass('box3Active',index>2)
            $('.box3').toggleClass('box3Active2',index>5)
        }
    })
    
    //box4
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=30%',
            end:'+=0%',
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 10);
                $('.box4_title div:first-child').toggleClass('beforeMove1',index>2)
                $('.box4_title div:last-child').toggleClass('beforeMove2',index>2)
            }
        })
    }

    ScrollTrigger.create({
        trigger:'.box4',
        start:wFlag?'top top+=20%':'top center',
        end:'+=160%',
        //markers:true,
        scrub:1,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 37);
            if(index==37){
                index=38
            }
            $('.box4_img').attr('src', `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/cresmo_box4_${index+1}.avif`)
            $('.box4_title div:first-child,.box4_title div:last-child,.box4_img').toggleClass('box4Active1',index>17)
            $('.box4_bg,.box4_text').toggleClass('box4Active2',index>17)
            $('.box4_color').toggleClass('box4Active3',index>24)
            $('.box4_icon').toggleClass('block',index>34)
            $('.box4_icon').toggleClass('box4Active4',index>34)
            if(!wFlag){
                $('.box4_items').toggleClass('box4Active2',index>34)
            }
        }
    })

    $('.box4_icon').on('animationend', function () {
        $(this).removeClass('box4Active4');
    });

    ScrollTrigger.create({
        trigger:'.box4',
        start:'top top+=4%',
        end:wFlag?'+=180%':'+=150%',
        pin:true,
    })

    ScrollTrigger.create({
        trigger:'.box4',
        start:'top+=20% top+=4%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .to('.box4_right img:last-child',{clipPath:'inset(0% 0% 0% 0%)'})
    })

    //box5
    $('.box5_play div p').click(function(){
        $('.box5_play').hide()
        $('.box5_video video')[0].play()
    })

    showUp('.box7_title')
    ScrollTrigger.create({
        trigger:'.box5',
        start:'top top+=4%',
        end:'+=450%',
        pin:true,
        scrub:1,
        animation:gsap.timeline()
            .to('.box7_item div:first-child p',{opacity:0,duration:0.1})
            .to('.box7_item div:first-child',{scale:2.1,zIndex:2})
            .to('.box7',{opacity:0,pointerEvents:'none',duration:0.2},'-=10%')
            .to({},{duration:0.3})
            .to('.box5_title div span:nth-child(2)',{background:'white',color:'#5BD1E4',duration:0.1})
            .to('.box5_title div span:nth-child(1)',{background:'transparent',color:'white',duration:0.1},'<')
            .to('.box5_video1',{opacity:0,duration:0.1},'<')
            .to({},{duration:0.3})
            .to('.box5_mask',{opacity:1,pointerEvents:'auto'})
            .to({},{duration:0.3})
            .to('.box7',{opacity:1,pointerEvents:'auto',duration:0.2})
            .to('.box7_item div:first-child',{scale:1,zIndex:1},'-=10%')
            .to('.box7_item div:first-child p',{opacity:1,duration:0.1})
            .to('.box7_item',{x:wFlag?'-26.5%':'-45.5%'})
            .to('.box6',{opacity:1,pointerEvents:'auto'},'<')
            .to('.box7_item div:last-child p',{opacity:0,duration:0.1})
            .to('.box7_item div:last-child',{scale:2.2,zIndex:4})
            .to('.box7',{opacity:0,pointerEvents:'none',duration:0.2},'-=10%')
            .to({},{duration:0.3})
    })

    //box8
    showUp('.box8_items')

    //box9
    showUp('.box9_title')
    ScrollTrigger.create({
        trigger:'.box9',
        start:'top top+=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .to('.box9_bg,.box9_icon',{clipPath:'inset(0% 0% 0% 0%)'})
    })

    ScrollTrigger.create({
        trigger:'.box9',
        start:'top top+=4%',
        end:'+=100%',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 16);
            $('.box9_img').attr('src', `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/cresmo_box9_${index+1}.avif`)
        }
    })
    ScrollTrigger.create({
        trigger:'.box9',
        start:wFlag?'top+=100% top+=4%':'top+=160% top+=4%',
        end:'+=50%',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 10);
            if(index>2 && index<6){
                $('.box9_img').attr('src', `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/cresmo_box9_18.avif`)
                $('.box9_icon img:nth-child(2)').css({opacity:1}).siblings().css({opacity:0})
            }
            if(index>5){
                $('.box9_img').attr('src', `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/cresmo_box9_19.avif`)
                $('.box9_icon img:nth-child(3)').css({opacity:1}).siblings().css({opacity:0})
            }
            if(index<2){
                $('.box9_img').attr('src', `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/cresmo_box9_17.avif`)
                $('.box9_icon img:nth-child(1)').css({opacity:1}).siblings().css({opacity:0})
            }
        }
    })
    ScrollTrigger.create({
        trigger:'.box9',
        start:'top top+=4%',
        end:'+=150%',
        pin:true,
    })

    //box10
    if(wFlag){
        showUp('.box10 .box10_item:first-child')
        showUp('.box10 .box10_item:last-child')
    }else{
        showUp('.box10 .box10_item:first-child div')
        showUp('.box10 .box10_item:last-child div')
    }

    if(wFlag){

        ScrollTrigger.create({
            trigger:'.box12',
            start:'top top+=4%',
            end:'+=50%',
            pin:true,
            scrub:1,
            // toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .to({},{duration:0.2})
                .to('.box12_title',{opacity:0})
                .to('.box12_bg',{filter:'blur(1rem) brightness(0.5)'},'<')
                .from('.box12_item',{opacity:0})
                .to({},{duration:0.2})
        })

        ScrollTrigger.create({
            trigger:'.box11',
            start:'top top+=40%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .from('.box11_img.desktop-only img:first-child',{x:'-50%',opacity:0})
                .from('.box11_img.desktop-only img:last-child',{x:'50%',opacity:0},'<')
        })

    }else{
        showUp('.box11_title')
    }

    //specs
    showUp('.specs_item1 img')

    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?6:1.5,
        loop:true
    })
})